// extracted by mini-css-extract-plugin
module.exports = {"overlay":"BookingDetails_overlay__FeeYC","modal-container":"BookingDetails_modal-container__G53sh","error-modal":"BookingDetails_error-modal__u_13J"};